import { Controller, useFormContext } from 'react-hook-form';

import { RangeDatepicker, RangeDatepickerProps } from '../RangeDatepicker';

interface Props extends RangeDatepickerProps {
	name: string;
}
export const FormRangeDatepicker = ({ name, disabled, ...rangeProps }: Props) => {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={{}}
			disabled={disabled}
			render={({ field: { onChange, value, disabled }, fieldState: { error } }) => (
				<RangeDatepicker
					{...rangeProps}
					range={value}
					onSelect={onChange}
					error={!!error}
					errors={error?.message ? [error?.message] : undefined}
					disabled={disabled}
				/>
			)}
		/>
	);
};
